import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import LoginButton from "../auth/LoginButton.jsx";
import Logo from "./Logo.jsx";
import Avatar from "./Avatar.jsx";
import { useState } from "react";
import AvatarMenu from "./AvatarMenu.jsx";
import "../../styles/common/header.css";

const Header = () => {
  const user = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);

  return (
    <header className="header">
      {/* Left */}
      <div className="header-left">
        <Logo />
      </div>

      {/* Center Nav */}
      <nav className="header-nav">
        <NavLink to="/" className="nav-link">
          Home
        </NavLink>

        <NavLink to="/f/visualizations" className="nav-link">
          Visualizations
        </NavLink>

        {user?.role === "admin" && (
          <NavLink to="/studio" className="nav-link">
            Studio
          </NavLink>
        )}

        {user?.role === "admin" && (
          <NavLink to="/errors" className="nav-link">
            Errors
          </NavLink>
        )}

        <NavLink to="/about" className="nav-link">
          About
        </NavLink>
      </nav>

      {/* Right */}
      <div className="header-right">
        {user?.firstName ? (
          <div className="profile-container">
            <span className="user-name">
              {user.firstName} {user.lastName}
            </span>

            <div className="avatar-container">
              <div className="avatar" onClick={() => setOpen(!open)}>
                <Avatar
                  avatar={user.avatar}
                  size={"2rem"}
                  firstName={user.firstName}
                  lastName={user.lastName}
                />
              </div>

              <AvatarMenu open={open} setOpen={setOpen} userId={user.userId} />
            </div>
          </div>
        ) : (
          <LoginButton />
        )}
      </div>
    </header>
  );
};

export default Header;
